/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Secure/view.blocks to change it.
import LockIcon from 'DesignSystem/Svgs/LockIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Secure({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/Secure/InApp/SecureIndicator/Secure"
  
}) {
  return (<React.Fragment
>
<LockIcon
  viewPath={`${viewPath}/LockIcon`}
 width={16}
 height={16}
 stroke="rgb(0,150,89)"
/>
{children}
</React.Fragment>)
}